export const UPDATE_ACTIVE_STATUS = 'PRESCREEN_UPDATE_ACTIVE_STATUS';
